export const lazyLoading = () => {
  const lazyImages = [].slice.call(document.querySelectorAll('img.lazy'));

  if ('IntersectionObserver' in window) {
    const lazyImageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const lazyImage: any = entry.target;

          const dataset = lazyImage.dataset;

          if (dataset.src) {
            lazyImage.src = dataset.src;
          }

          if (dataset.srcset) {
            lazyImage.srcset = dataset.srcset;
          }

          lazyImage.classList.remove('lazy');
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });

    lazyImages.forEach((lazyImage: HTMLImageElement) => {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    lazyImages.forEach((lazyImage: HTMLImageElement) => {
      lazyImage.src = lazyImage.src || lazyImage.dataset.src || '';
      lazyImage.srcset = lazyImage.srcset || lazyImage.dataset.srcset || '';
      lazyImage.classList.remove('lazy');
    });
  }
};
